/* eslint-disable @typescript-eslint/no-explicit-any */
export const isEqual = (first: any, second: any): boolean => {
  if (first === second) {
    return true;
  }
  if ((first === undefined || second === undefined || first === null || second === null) && (first || second)) {
    return false;
  }
  const firstType = first?.constructor.name;
  const secondType = second?.constructor.name;
  if (firstType !== secondType) {
    return false;
  }
  if (Array.isArray(first) && Array.isArray(second)) {
    if (first.length !== second.length) {
      return false;
    }
    let equal = true;
    for (let i = 0; i < first.length; i++) {
      if (!isEqual(first[i], second[i])) {
        equal = false;
        break;
      }
    }
    return equal;
  }
  if (firstType === 'Object') {
    let equal = true;
    const fKeys = Object.keys(first);
    const sKeys = Object.keys(second);
    if (fKeys.length !== sKeys.length) {
      return false;
    }
    for (const item of fKeys) {
      if (first[item] && second[item]) {
        if (first[item] === second[item]) {
          continue;
        }
        if (first[item] && (first[item].constructor.name === 'Array' || first[item].constructor.name === 'Object')) {
          equal = isEqual(first[item], second[item]);
          if (!equal) {
            break;
          }
        } else if (first[item] !== second[item]) {
          equal = false;
          break;
        }
      } else if ((first[item] && !second[item]) || (!first[item] && second[item])) {
        equal = false;
        break;
      }
    }
    return equal;
  }
  return first === second;
};
